export const getPagination = (headers = {}) => {
  const page = Number.parseInt(headers['x-pagination-current-page']) || 1;
  const pages = Number.parseInt(headers['x-pagination-page-count']) || 1;
  const perPage = Number.parseInt(headers['x-pagination-per-page']) || 10;
  const total = Number.parseInt(headers['x-pagination-total-count']) || 0;
  return {
    page,
    pages,
    perPage,
    total,
  };
};
